import React, { ReactNode } from 'react';
import { Typography } from '@material-ui/core';
import { ToolboxAction } from './types';

export const getToolboxContent = (type: ToolboxAction | undefined, isPresentationModeEnabled: boolean) => {
  let content: NonNullable<ReactNode> = <></>;

  switch (type) {
    case 'NOTES':
      content = notesTooltipContent;
      break;
    case 'BOOKMARK':
      content = bookmarkTooltipContent;
      break;
    case 'SOLUTIONS':
      content = solutionsTooltipContent;
      break;
    case 'SETTINGS':
      content = settingsTooltipContent;
      break;
    case 'MANUAL':
      content = manualTooltipContent;
      break;
    case 'KNOWLEDGE_BASE':
      content = downloadsTooltipContent;
      break;
    case 'PRINT':
      content = printTooltipContent;
      break;
    case 'PRESENTATION_MODE':
      content = isPresentationModeEnabled
        ? stopPresentationModeTooltipContent
        : presentationModeTooltipContent;
      break;

    case 'GEOGEBRA_SCIENTIFIC':
      content = scientificCalculatorModeTooltipContent;
      break;
    case 'GEOGEBRA_GRAPHING':
      content = graphicCalculatorModeTooltipContent;
      break;

    case 'PRESENTATION_MODE_UP':
      content = <Typography variant="subtitle2">Naar boven</Typography>;
      break;

    case 'PRESENTATION_MODE_DOWN':
      content = <Typography variant="subtitle2">Naar onder</Typography>;
      break;

    default:
      break;
  }
  return content;
};

export const notesTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Snelle notities maken
    </Typography>
    <Typography variant="subtitle2">
      Jij én je leerlingen kunnen in de methode notities maken. Zo kunnen ze de belangrijkste inhoud
      aanduiden.
    </Typography>
  </>
);

export const bookmarkTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Breng je leerlingen in één klik, exact waar ze moeten zijn
    </Typography>
    <Typography variant="subtitle2">
      Wanneer jij een bladwijzer plaatst, zien je leerlingen die op hun startscherm. In één klik
      zijn ze bij de juiste les.
    </Typography>
  </>
);

export const solutionsTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Zet de oplossingsmodus aan
    </Typography>
    <Typography variant="subtitle2">Toon de oplossingen van de interactieve oefeningen.</Typography>
  </>
);

export const settingsTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Verwijder inhoud en voeg extra’s toe, in je eigen versie
    </Typography>
    <Typography variant="subtitle2">
      Maak samen met je collega’s een nieuwe versie van je traject.
    </Typography>
    <Typography variant="subtitle2">
      Voeg je eigen BookWidgets toe, dan stromen resultaten gewoon door.
    </Typography>
  </>
);

export const manualTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Lees de handleiding
    </Typography>
    <Typography variant="subtitle2">De auteurs geven didactische wenken voor deze les.</Typography>
  </>
);

export const downloadsTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Download extra materiaal
    </Typography>
    <Typography variant="subtitle2">
      Jaarplannen, toetsen, extra werkbladen en teksten. Alles bewerkbaar en printbaar.
    </Typography>
    <Typography variant="subtitle2">
      Contacteer ons als je specifiek materiaal wil inkijken.
    </Typography>
  </>
);

export const printTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Download printbaar leerboek
    </Typography>
    <Typography variant="subtitle2">
      Een handige pdf van deze pagina, die jij of je leerlingen eventueel kunnen printen.
    </Typography>
    <Typography variant="subtitle2">Klik en download een voorproefje.</Typography>
  </>
);

export const presentationModeTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Krachtige instructie met de presentatiemodus
    </Typography>
    <Typography variant="subtitle2">
      Laat de laptops nog even gesloten, terwijl jij met de presentatiemodus instructie geeft.
    </Typography>
    <Typography variant="subtitle2">Klik om te starten.</Typography>
  </>
);

export const stopPresentationModeTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Krachtige instructie met de presentatiemodus
    </Typography>
    <Typography variant="subtitle2">
      Laat de laptops nog even gesloten, terwijl jij met de presentatiemodus instructie geeft.
    </Typography>
    <Typography variant="subtitle2">Klik om de presentatiemodus te verlaten.</Typography>
  </>
);

export const scientificCalculatorModeTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Wetenschappelijk rekentoestel
    </Typography>
    <Typography variant="subtitle2">
      Maak berekeningen met het wetenschappelijk rekentoestel van GeoGebra zonder het platform te
      moeten verlaten.
    </Typography>
  </>
);

export const graphicCalculatorModeTooltipContent: NonNullable<React.ReactNode> = (
  <>
    <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
      Grafisch rekentoestel
    </Typography>
    <Typography variant="subtitle2">
      Construeer grafieken met GeoGebra tijdens de oefeningen en pas de breedte van het geplitst
      scherm aan wanneer nodig.
    </Typography>
  </>
);
